import { type CreateBlockData } from '@/lib/builder/types'

import {
  type ContentSectionCreate,
  type ContentSection,
} from '../../../WebsiteBuilder.types'

export const createContentData = ({
  brandId,
}: CreateBlockData<ContentSection>): ContentSectionCreate => ({
  brandId,
  params: {
    action: {
      params: {
        label: 'Order Online',
        url: 'https://exampleowner.com/freshonsunset/order',
      },
      type: 'external',
    },
    alignment: 'left',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    header: 'Content Section',
    layout: 'generic',
    media: {
      params: {
        image:
          'https://static-content.owner.com/309e231a-8c34-45ab-bcf8-e2fc40488472',
      },
      type: 'image',
    },
  },
  type: 'content',
})
